const euroFormatter = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });

// Montant en euros, toujours 2 décimales, séparateurs fr-FR. À préférer à `renderAsPrice`, qui se trompe sur
// les centimes < 10 (`12.05` → « 12,5 € ») et sur les montants négatifs (`-50.30` → « -51,70 € »).
export function formatEuroAmount(amount: number): string {
    return euroFormatter.format(amount);
}

export function renderAsPrice(price?: number | null) {
    if (price === null || price === undefined) {
        return '-';
    }
    const eurosPart = Math.floor(price);
    const centsPart = Math.round((price - eurosPart) * 100);
    const formattedEuros = eurosPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0');
    return `${formattedEuros},${centsPart}${centsPart === 0 ? '0' : ''}\u00A0€`;
}

export function round(number: number, numberOfDecimals = 0): number {
    const multiplier = Math.pow(10, numberOfDecimals);
    return Math.round(number * multiplier) / multiplier;
}

export function roundPrice(number: number): number {
    return round(number, 2);
}
